import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import ModuleHeader from "../components/ModuleHeader";
import WeightIcon from "@/assets/img/cpm/weight.png";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
const MaterialProcurement = ({ className = "", data: externalData, }) => {
    // 本地状态管理数据（优先用外部传入，否则模拟）
    const [procurementData, setProcurementData] = useState({
        today: 20,
        month: 200,
        percentage: 75,
    });
    // 模拟接口请求（若未传入外部数据）
    useEffect(() => {
        if (!externalData) {
            // 模拟异步接口请求（实际项目替换为 axios/fetch）
            setTimeout(() => {
                const mockData = {
                    today: Math.floor(Math.random() * 50) + 10, // 随机今日数据
                    month: Math.floor(Math.random() * 300) + 50, // 随机本月数据
                    percentage: Math.floor(Math.random() * 30) + 70, // 随机百分比
                };
                setProcurementData(mockData);
            }, 1000); // 延迟1秒模拟接口耗时
        }
        else {
            // 若外部传入数据，直接使用
            setProcurementData(externalData);
        }
    }, [externalData]);
    // 仪表盘配置：仅添加内圈间隔环，其余完全保留你原有的逻辑
    const getGaugeOption = () => {
        const value = procurementData.percentage;
        return {
            series: [
                // 1. 内圈间隔环
                {
                    type: "gauge",
                    radius: "46%", // 比外层小，形成间隔
                    center: ["50%", "50%"],
                    startAngle: 180,
                    endAngle: 0,
                    min: 0,
                    max: 100,
                    splitNumber: 1,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            width: 2, // 细环宽度
                            color: [[1, "#1A6BA8"]], // 亮蓝色间隔环
                        },
                    },
                    progress: { show: false }, // 仅显示环形，无进度
                    pointer: { show: false },
                    axisTick: { show: false },
                    splitLine: { show: false },
                    axisLabel: { show: false },
                    detail: { show: false },
                    data: [{ value: 0 }],
                },
                // 2. 外层进度环
                {
                    type: "gauge",
                    radius: "76%",
                    center: ["50%", "50%"],
                    min: 0,
                    max: 100,
                    splitNumber: 1,
                    axisLine: {
                        lineStyle: {
                            width: 15, // 环形总厚度
                            color: [
                                [0.2, "#0C5071"], // 外层背景色
                                [1, "#0C5071"], // 外层背景色
                            ],
                        },
                    },
                    progress: {
                        show: true,
                        overlap: false,
                        width: 12, // 进度条宽度
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                { offset: 0, color: "#2381F0" },
                                { offset: 0.5, color: "#28BEC8" },
                                { offset: 1, color: "#2CE4AF" },
                            ]),
                        },
                    },
                    pointer: { show: false },
                    axisTick: { show: false },
                    splitLine: { show: false },
                    axisLabel: { show: false },
                    detail: {
                        show: true,
                        offsetCenter: [0, "6%"],
                        fontSize: 19,
                        fontWeight: "bold",
                        color: "#00ECD9",
                        formatter: "{value}%",
                    },
                    data: [{ value }],
                },
            ],
        };
    };
    return (_jsxs("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
       
        flex flex-col 
        min-h-0
        ${className}
        flex-shrink-0
      `, children: [_jsx(ModuleHeader, { title: "\u539F\u6599\u91C7\u8D2D" }), _jsxs("div", { className: "flex-1 w-full min-h-0 flex flex-shrink-0", children: [_jsx("div", { className: "w-[1.60rem] flex items-center justify-center ", children: _jsx(ReactEcharts, { option: getGaugeOption(), style: { width: "100%", height: "100%" } }) }), _jsxs("div", { className: "flex-1 flex items-center justify-center gap-0", children: [_jsx("div", { children: _jsxs("div", { className: "flex items-center", children: [_jsx("img", { src: WeightIcon, alt: "\u91CD\u91CF\u56FE\u6807", style: {
                                                width: "0.52rem",
                                                height: "0.68rem",
                                                maxHeight: "100%",
                                                maxWidth: "100%",
                                                objectFit: "cover",
                                                objectPosition: "center",
                                            } }), _jsxs("div", { className: "flex flex-col items-start", children: [_jsx("span", { className: "text-white text-[0.14rem] whitespace-nowrap", children: "\u4ECA\u65E5\u5230\u5382\uFF08\u5428\uFF09" }), _jsx("span", { className: "text-[0.32rem] font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent", children: procurementData.today })] })] }) }), _jsx("div", { children: _jsxs("div", { className: "flex items-center", children: [_jsx("img", { src: WeightIcon, alt: "\u91CD\u91CF\u56FE\u6807", style: {
                                                width: "0.52rem",
                                                height: "0.68rem",
                                                maxHeight: "100%",
                                                maxWidth: "100%",
                                                objectFit: "cover",
                                                objectPosition: "center",
                                            } }), _jsxs("div", { className: "flex flex-col items-start", children: [_jsx("span", { className: "text-white text-[0.14rem] whitespace-nowrap", children: "\u672C\u6708\u5230\u5382\uFF08\u5428\uFF09" }), _jsx("span", { className: "text-[0.32rem] font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent", children: procurementData.month })] })] }) })] })] })] }));
};
export default MaterialProcurement;
